import React, { Component, Fragment } from 'react';
import moment from 'moment';
import { CollapseEvent } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { classNames, defaultClasses, isEnumValid, isFunction, isTouchableDevice } from '@philips-internal/oswald-ui-utils';
import { ReactComponent as DownIcon } from '../../../../resources/assets/components/arrow-down-md-dark.svg';
import { ReactComponent as UpIcon } from '../../../../resources/assets/components/arrow-up-md-dark.svg';
import { DatePickerContent } from '../components/date-picker-content.js';
import { DatePickerEventsPanel } from '../components/date-picker-events-panel.js';
import { DatePickerTimeSpan } from '../components/date-picker-time-span.js';
import { DatePickerWeekContent } from '../components/date-picker-week-content.js';
import { DatePickerMode } from '../date-picker-constants.js';
import { getDataGrid } from '../date-picker-util.js';
class DatePickerBasic extends Component {
    getClassName() {
        const { enabled, mode, showExpander } = this.props;
        return classNames({
            'c-date-picker': true,
            'c-date-picker__colapsed': mode === DatePickerMode.WEEK && Boolean(showExpander),
            'c-date-picker__expander-mode': Boolean(showExpander),
            'c-date-picker--touchable-device': isTouchableDevice(),
            [`c-date-picker--${mode}`]: isEnumValid(DatePickerMode, mode),
            ...defaultClasses({ enabled }),
        });
    }
    getClassNameWeekMonthAction() {
        const { isExpandedWeekMonthly } = this.props;
        return classNames({
            'c-date-picker-week-month-transition-action': true,
            'c-date-picker-week-month-transition-action--is-expanded': Boolean(isExpandedWeekMonthly),
        });
    }
    handleOpenCloseActions() {
        const { isExpandedWeekMonthly, onChangeWeekMonthly } = this.props;
        if (isFunction(onChangeWeekMonthly)) {
            onChangeWeekMonthly(!isExpandedWeekMonthly);
        }
    }
    renderEventsPanel() {
        const { noAppointmentsExpression, showEvents, value, events } = this.props;
        if (!showEvents || !value) {
            return null;
        }
        return (React.createElement(DatePickerEventsPanel, { data: events, date: value, noAppointmentsExpression: MessageService.translate(noAppointmentsExpression) }));
    }
    renderContentMode() {
        const { date, enabled, events, isModalWrapped, loading, mode, onArrowClick, onCellClick, onNavigate, onTitleClick, rangeEnabled, ranges, showExpander, showNavigationArrows, specialDays = [], value, } = this.props;
        const grid = getDataGrid({ date, events, mode, specialDays });
        if (mode === DatePickerMode.WEEK) {
            return (React.createElement(Fragment, null,
                React.createElement(DatePickerWeekContent, { currentDate: value, data: grid, date: date, enabled: enabled, isModalWrapped: isModalWrapped, loading: loading, mode: mode, monthDate: date, onArrowClick: onArrowClick, onCellClick: onCellClick, onNavigate: onNavigate, onTitleClick: onTitleClick, rangeEnabled: rangeEnabled, ranges: ranges, showNavigationArrows: showNavigationArrows, value: value })));
        }
        return (React.createElement(Fragment, null,
            React.createElement(DatePickerTimeSpan, { date: date, enableNext: enabled, enablePrev: enabled, mode: mode, onArrowClick: onArrowClick, onTitleClick: onTitleClick, showNavigationArrows: showNavigationArrows }),
            React.createElement(DatePickerContent, { currentDate: value, data: grid, enabled: enabled, isModalWrapped: isModalWrapped, loading: loading, mode: mode, monthDate: date, onArrowClick: onArrowClick, onClick: onCellClick, rangeEnabled: rangeEnabled, ranges: ranges, showExpander: showExpander })));
    }
    renderActions() {
        const { weekMonthly } = this.props;
        if (!weekMonthly) {
            return null;
        }
        return (React.createElement("div", { className: "c-date-picker-week-month-transition", onClick: this.handleOpenCloseActions },
            React.createElement("div", { className: this.getClassNameWeekMonthAction() })));
    }
    onExpand(mode) {
        const { handleChangeMode, onCollapse } = this.props;
        if (isFunction(onCollapse)) {
            onCollapse(new CollapseEvent({ collapsed: mode === DatePickerMode.WEEK }));
        }
        if (isFunction(handleChangeMode)) {
            handleChangeMode(mode);
        }
    }
    renderExpander() {
        const { isModalWrapped, mode, showExpander } = this.props;
        if (isModalWrapped || (mode !== DatePickerMode.MONTHLY && mode !== DatePickerMode.WEEK) || !showExpander) {
            return null;
        }
        return (React.createElement("div", { className: "c-date-picker__expander" }, mode === DatePickerMode.MONTHLY
            ? React.createElement(UpIcon, { onClick: () => this.onExpand(DatePickerMode.WEEK) })
            : React.createElement(DownIcon, { onClick: () => this.onExpand(DatePickerMode.MONTHLY) })));
    }
    render() {
        return (React.createElement("div", { className: this.getClassName() },
            this.renderContentMode(),
            this.renderActions(),
            this.renderExpander(),
            this.renderEventsPanel()));
    }
}
DatePickerBasic.defaultProps = {
    clearExpression: 'tws.datepicker.clear',
    date: moment.utc(),
    enabled: true,
    events: [],
    mode: DatePickerMode.MONTHLY,
    noAppointmentsExpression: 'tws.datepicker.no-appointments',
    rangeEnabled: false,
    ranges: [],
    specialDays: [],
    todayExpression: 'tws.datepicker.today',
};
export { DatePickerBasic, };
//# sourceMappingURL=date-picker-basic.js.map